export { default } from './useSlotProps';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/useSlotProps/index.js
// module id = 101
// module chunks = 25